import { useParams, useRouteContext } from '@tanstack/react-router'

import { type UserMeTenantExEntity } from '@/libs/api'

/**
 * 表示中のテナントを取得
 * - URLのパスからテナントキーを取得し、ログインユーザーのテナントリストから該当するテナントを取得
 */
export const useCurrentTenant = (): UserMeTenantExEntity => {
  const { auth } = useRouteContext({
    from: '/_protected/$tenantKey'
  })

  const tenantKey = useParams({
    from: '/_protected/$tenantKey',
    select: ({ tenantKey }) => tenantKey
  })

  const currentTenant = auth.user.tenants.find(
    ({ key }: UserMeTenantExEntity) => key === tenantKey
  )

  if (!currentTenant) {
    throw new Error('Current UserMeTenantExEntity not found')
  }

  return currentTenant
}
